angular.module("vgresiduos").controller("RawMaterialEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidades/materia-prima/${$stateParams.id}`);
		};
	}
]);
